import classNames from 'classnames';

const TabBarControlled = ({ className = "", tabs, value, onChange }) => {
  const handleSelectChange = (event) => {
    const selectedTab = tabs.find(tab => tab.name === event.target.value);
    if (selectedTab && onChange) {
      onChange(selectedTab.key);
    }
  };

  return (
    <div className={classNames("px-4 sm:px-0", className)}>
      <div className="sm:hidden">
        <label htmlFor="question-tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="question-tabs"
          value={tabs.find(tab => tab.key === value)?.name || ''}
          onChange={handleSelectChange}
          className="block w-full rounded-md border-gray-300 text-base font-medium text-gray-900 shadow-sm focus:border-rose-500 focus:ring-rose-500"
        >
          {tabs.map((tab) => (
            <option key={tab.key} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav
          className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
          aria-label="Tabs"
        >
          {tabs.map((tab, tabIdx) => {
            const isActive = tab.key === value;

            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => !tab.disabled && onChange && onChange(tab.key)}
                disabled={tab.disabled}
                className={classNames(
                  "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-6 text-sm font-medium text-center hover:bg-gray-50 focus:z-10 focus:outline-none",
                  {
                    "cursor-not-allowed bg-gray-50": tab.disabled,
                    "rounded-l-lg": tabIdx === 0,
                    "rounded-r-lg": tabIdx === tabs.length - 1
                  }
                )}
              >
                <div
                  aria-current={isActive ? "page" : undefined}
                  className={classNames(
                    isActive ? "text-gray-900" : "text-gray-500 hover:text-gray-700"
                  )}
                >
                  <span>{tab.name}</span>
                  <span
                    aria-hidden="true"
                    className={classNames(
                      isActive ? "bg-rose-500" : "bg-transparent",
                      "absolute inset-x-0 bottom-0 h-0.5"
                    )}
                  />
                </div>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default TabBarControlled;
